import clsx from "clsx"
import { CSSProperties } from "react"
import { useTranslation } from "react-i18next"

import { Order, OrderPoint } from "@/types"
import { formatDelay, formatTime, OrderUtils } from "@/utils"

import cls from "./OrderProgressBar.module.scss"

export const OrderProgressBar = ({ order }: { order: Order }) => {
  const progress = OrderUtils.getProgress(order)
  const isInProgress = progress > 0 && progress < 100

  return (
    <div
      className={clsx(cls.progress, isInProgress && cls.inProgress)}
      style={{ "--progress": `${progress}%` } as CSSProperties}
    >
      <div className={cls.start} />

      {order.pickup && <Point point={order.pickup} />}
      {order.delivery && <Point point={order.delivery} />}

      {!OrderUtils.isSinglePointOrder(order) && (
        <>
          {order.driver_id && isInProgress && <div className={clsx("driver-marker info", cls.marker)} />}

          {Boolean(order.distance) && <div className={cls.distance}>{OrderUtils.getRealOrderDistance(order)} km</div>}
        </>
      )}
    </div>
  )
}

const Point = ({ point }: { point: OrderPoint }) => {
  const { t } = useTranslation()

  const pointDelay = OrderUtils.getPointDelay(point)

  return (
    <div className={clsx(cls.point, `status-${point.state}`)}>
      <div className={cls.textWrapper}>
        <span className={cls.time}>{formatTime(OrderUtils.getPointTime(point))}</span>

        {OrderUtils.shouldShowDelay(point, pointDelay) && (
          <span className={`text-${OrderUtils.getPointDelayColor(pointDelay)}`}>
            {formatDelay(pointDelay!, " (", ")")}
          </span>
        )}
      </div>

      <div className={cls.label}>
        <span>{OrderUtils.isPointPickup(point) ? "P" : "D"}</span>
      </div>

      <div className={cls.textWrapper}>{t(`orders:${point.state}`)}</div>
    </div>
  )
}
